import React from 'react';
import BaseButton from 'components/atoms/baseButton';
import ChevronDoubleDownIcon from 'components/atoms/icons/chevronDoubleDownIcon';

import s from './styles.module.scss';

interface IExpandButton {
  expanded: boolean;
  setExpanded: (value: boolean) => void;
}

const ExpandButton: React.FC<IExpandButton> = ({ expanded, setExpanded }) => {
  return (
    <div className={s['expand-button-wrapper']}>
      <BaseButton
        dataCy="patient-key-note-expand-button"
        icon={<ChevronDoubleDownIcon />}
        type="secondary"
        className={s['expand-button']}
        onClick={() => {
          setExpanded(!expanded);
        }}
      />
    </div>
  );
};

export default ExpandButton;
